import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { type SocialMediaType } from '@prisma/client';
import { type SVGProps } from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export const InstagramIcon = (props: IconProps) => (
  <svg
    width="24"
    height="26"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.1681 1.66663C6.68899 1.66663 5.67149 1.67022 5.47371 1.68663C4.75974 1.74599 4.31547 1.85844 3.83146 2.09948C3.45845 2.28476 3.16427 2.49952 2.87394 2.80057C2.3452 3.34959 2.02474 4.02503 1.90874 4.82792C1.85234 5.2177 1.83593 5.29719 1.8326 7.28813C1.83132 7.95177 1.8326 8.82518 1.8326 9.99669C1.8326 13.4739 1.83645 14.4907 1.85311 14.6881C1.91079 15.383 2.01975 15.8203 2.25047 16.2985C2.69141 17.214 3.53356 17.9012 4.52568 18.1576C4.86921 18.2461 5.24863 18.2948 5.73571 18.3179C5.94208 18.3269 8.04553 18.3333 10.1503 18.3333C12.255 18.3333 14.3597 18.3307 14.561 18.3205C15.125 18.2939 15.4525 18.25 15.8146 18.1564C16.3065 18.0302 16.765 17.7981 17.158 17.4763C17.5509 17.1545 17.869 16.7508 18.0898 16.2934C18.316 15.8267 18.4308 15.3728 18.4827 14.7141C18.494 14.5705 18.4987 12.281 18.4987 9.99451C18.4987 7.70765 18.4936 5.42233 18.4823 5.27873C18.4297 4.60944 18.315 4.1594 18.0815 3.68372C17.8898 3.29433 17.6771 3.00353 17.3681 2.7062C16.817 2.17949 16.1427 1.85895 15.3392 1.74304C14.9499 1.68676 14.8723 1.67009 12.8804 1.66663H10.1681Z"
      fill="url(#paint0_radial_9134_11474)"
    />
    <path
      d="M10.1664 3.75C8.46901 3.75 8.25599 3.75742 7.58932 3.78776C6.92396 3.81823 6.46979 3.92357 6.0724 4.07813C5.66133 4.23776 5.31263 4.4513 4.96523 4.79883C4.61758 5.14622 4.40404 5.49492 4.24388 5.90586C4.08893 6.30339 3.98346 6.75768 3.95352 7.42279C3.92383 8.08945 3.91602 8.3026 3.91602 10C3.91602 11.6974 3.92357 11.9098 3.95378 12.5764C3.98438 13.2418 4.08971 13.696 4.24414 14.0934C4.40391 14.5044 4.61745 14.8531 4.96497 15.2005C5.31224 15.5482 5.66094 15.7622 6.07174 15.9219C6.4694 16.0764 6.9237 16.1818 7.58893 16.2122C8.2556 16.2426 8.46849 16.25 10.1658 16.25C11.8633 16.25 12.0757 16.2426 12.7423 16.2122C13.4077 16.1818 13.8624 16.0764 14.26 15.9219C14.671 15.7622 15.0191 15.5482 15.3664 15.2005C15.7141 14.8531 15.9276 14.5044 16.0878 14.0935C16.2414 13.696 16.3469 13.2417 16.3781 12.5766C16.4081 11.9099 16.4159 11.6974 16.4159 10C16.4159 8.3026 16.4081 8.08958 16.3781 7.42292C16.3469 6.75755 16.2414 6.30339 16.0878 5.90599C15.9276 5.49492 15.7141 5.14622 15.3664 4.79883C15.0188 4.45117 14.6711 4.23763 14.2596 4.07813C13.8612 3.92357 13.4068 3.81823 12.7414 3.78776C12.0747 3.75742 11.8625 3.75 10.1646 3.75H10.1664ZM9.60573 4.8763C9.77213 4.87604 9.95781 4.8763 10.1664 4.8763C11.8352 4.8763 12.0329 4.88229 12.6919 4.91224C13.3013 4.9401 13.632 5.04193 13.8523 5.12747C14.144 5.24076 14.352 5.37617 14.5706 5.59492C14.7893 5.81367 14.9247 6.02201 15.0383 6.31367C15.1238 6.53372 15.2258 6.86445 15.2535 7.47383C15.2835 8.13268 15.29 8.3306 15.29 9.99857C15.29 11.6665 15.2835 11.8645 15.2535 12.5233C15.2257 13.1327 15.1238 13.4634 15.0383 13.6835C14.925 13.9751 14.7893 14.1828 14.5706 14.4014C14.3518 14.6202 14.1441 14.7556 13.8523 14.8689C13.6323 14.9548 13.3013 15.0564 12.6919 15.0842C12.0331 15.1142 11.8352 15.1207 10.1664 15.1207C8.49753 15.1207 8.29974 15.1142 7.64089 15.0842C7.03151 15.0561 6.70078 14.9543 6.48034 14.8687C6.18867 14.7555 5.98034 14.6201 5.76159 14.4013C5.54284 14.1826 5.40742 13.9747 5.29388 13.6829C5.20833 13.4629 5.10638 13.1322 5.07865 12.5228C5.0487 11.8639 5.04271 11.666 5.04271 9.997C5.04271 8.32799 5.0487 8.13112 5.07865 7.47227C5.10651 6.86289 5.20833 6.53216 5.29388 6.31185C5.40716 6.02018 5.54284 5.81185 5.76159 5.5931C5.98034 5.37435 6.18867 5.23893 6.48034 5.12539C6.70065 5.03945 7.03151 4.93789 7.64089 4.9099C8.21745 4.88385 8.44089 4.87604 9.60573 4.87474V4.8763ZM13.5026 5.91406C13.3543 5.91406 13.2092 5.95806 13.0859 6.04048C12.9626 6.1229 12.8664 6.24005 12.8097 6.37711C12.7529 6.51417 12.7381 6.66498 12.767 6.81048C12.796 6.95597 12.8675 7.08961 12.9724 7.19448C13.0773 7.29936 13.2109 7.37077 13.3564 7.39968C13.5019 7.42859 13.6528 7.4137 13.7898 7.3569C13.9268 7.30009 14.044 7.20392 14.1263 7.08055C14.2087 6.95718 14.2527 6.81215 14.2526 6.6638C14.2526 6.24974 13.9167 5.9138 13.5026 5.9138V5.91406ZM10.1664 6.79036C8.39388 6.79036 6.95677 8.22747 6.95677 10C6.95677 11.7725 8.39388 13.209 10.1664 13.209C11.9389 13.209 13.3757 11.7725 13.3757 10C13.3757 8.22747 11.9389 6.79036 10.1664 6.79036ZM10.1664 7.91667C11.3169 7.91667 12.2497 8.84935 12.2497 10C12.2497 11.1505 11.3169 12.0833 10.1664 12.0833C9.01575 12.0833 8.08307 11.1505 8.08307 10C8.08307 8.84935 9.01575 7.91667 10.1664 7.91667Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_9134_11474"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.25914 19.617) rotate(-90) scale(16.5179 15.3629)"
      >
        <stop stopColor="#FFDD55" />
        <stop offset="0.1" stopColor="#FFDD55" />
        <stop offset="0.5" stopColor="#FF543E" />
        <stop offset="1" stopColor="#C837AB" />
      </radialGradient>
    </defs>
  </svg>
);

export const TikTokIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.70631 7.87649V7.09716C7.43651 7.05429 7.164 7.0308 6.89086 7.02687C4.24663 7.02127 1.90553 8.73951 1.11148 11.2687C0.317454 13.7979 1.25472 16.5511 3.42532 18.0654C1.79937 16.3205 1.34788 13.7804 2.27255 11.5797C3.19722 9.37891 5.32536 7.92857 7.70631 7.87649Z"
      fill="#25F4EE"
    />
    <path
      d="M7.85468 16.7048C9.33315 16.7028 10.5484 15.5348 10.6132 14.0537V0.836841H13.0212C12.9721 0.560672 12.9486 0.280521 12.9511 0L9.65756 0V13.2041C9.6028 14.6928 8.38467 15.8719 6.89911 15.8743C6.45518 15.8705 6.01848 15.7611 5.625 15.5549C5.88001 15.9092 6.21491 16.198 6.6024 16.3979C6.98988 16.5977 7.41896 16.7028 7.85468 16.7048ZM17.5188 5.32126V4.58662C16.6326 4.58693 15.766 4.32469 15.0279 3.83282C15.675 4.58708 16.5494 5.10956 17.5188 5.32126Z"
      fill="#25F4EE"
    />
    <path
      d="M15.0267 3.83295C14.2996 3.00272 13.8988 1.93548 13.8991 0.830566H13.02C13.1335 1.44146 13.37 2.02275 13.715 2.53895C14.0601 3.05515 14.5063 3.49544 15.0267 3.83295ZM6.89152 10.3296C5.62279 10.3361 4.52132 11.2077 4.22 12.4435C3.91866 13.6794 4.49481 14.9622 5.6174 15.5551C5.00914 14.713 4.9232 13.5999 5.39496 12.674C5.86678 11.7481 6.81653 11.1657 7.85347 11.1665C8.12996 11.1699 8.40455 11.2129 8.66891 11.2942V7.93406C8.39894 7.89351 8.12645 7.87217 7.85347 7.8702H7.70694V10.4254C7.4412 10.354 7.16653 10.3217 6.89152 10.3296Z"
      fill="#FE2C55"
    />
    <path
      d="M17.5174 5.32129V7.8765C15.8768 7.87331 14.2788 7.35259 12.9498 6.38808V13.1019C12.9427 16.4521 10.2324 19.1642 6.89137 19.1642C5.65061 19.1664 4.43974 18.7825 3.42578 18.0655C5.11794 19.8904 7.75143 20.4911 10.0643 19.5798C12.3773 18.6684 13.8984 16.4307 13.8989 13.9388V7.24408C15.2325 8.20227 16.8325 8.71622 18.473 8.71334V5.42349C18.1518 5.42247 17.8316 5.38822 17.5174 5.32129Z"
      fill="#FE2C55"
    />
    <path
      d="M12.9521 13.102V6.38819C14.2852 7.34716 15.8855 7.86118 17.5261 7.85745V5.30221C16.5568 5.09697 15.6804 4.5813 15.0289 3.83295C14.5085 3.49544 14.0622 3.05515 13.7172 2.53895C13.3722 2.02275 13.1357 1.44146 13.0222 0.830566H10.6141V14.0538C10.5659 15.2336 9.7779 16.2533 8.65069 16.5945C7.52346 16.9358 6.30436 16.5237 5.6132 15.5678C4.49063 14.975 3.91448 13.6921 4.2158 12.4563C4.51714 11.2205 5.61858 10.3489 6.88731 10.3424C7.16386 10.3449 7.4386 10.3879 7.70276 10.4702V7.91493C5.30842 7.95559 3.1642 9.411 2.23693 11.6249C1.30965 13.8388 1.77445 16.393 3.42175 18.1358C4.4457 18.8292 5.65833 19.1885 6.8937 19.1643C10.2347 19.1643 12.945 16.4522 12.9521 13.102Z"
      fill="black"
    />
  </svg>
);

export const LinkedInIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.550781 1.43268C0.550781 0.641645 1.21247 0 2.02874 0H19.0728C19.8891 0 20.5508 0.641645 20.5508 1.43268V18.5673C20.5508 19.3586 19.8891 20 19.0728 20H2.02874C1.21247 20 0.550781 19.3586 0.550781 18.5673V1.43268Z"
      fill="#006699"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.14998 16.6665V7.67006H4.11312V16.6665H7.14998ZM5.63153 6.44175C6.69055 6.44175 7.3497 5.75093 7.3497 4.88759C7.32996 4.00483 6.69055 3.33317 5.65162 3.33317C4.6128 3.33317 3.93359 4.00483 3.93359 4.88759C3.93359 5.75093 4.5926 6.44175 5.61174 6.44175H5.63153Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83203 16.6665H11.8689V11.6425C11.8689 11.3736 11.8886 11.105 11.9688 10.9128C12.1883 10.3756 12.688 9.81921 13.527 9.81921C14.6258 9.81921 15.0654 10.6442 15.0654 11.8536V16.6665H18.102V11.5081C18.102 8.74477 16.6038 7.45896 14.6058 7.45896C12.9675 7.45896 12.2483 8.36062 11.8487 8.97478H11.8689V7.67006H8.83211C8.87197 8.51423 8.83203 16.6665 8.83203 16.6665Z"
      fill="white"
    />
  </svg>
);

export const FacebookIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10910_14879)">
      <path
        d="M8.95156 19.9C4.20156 19.05 0.601562 14.95 0.601562 10C0.601562 4.5 5.10156 0 10.6016 0C16.1016 0 20.6016 4.5 20.6016 10C20.6016 14.95 17.0016 19.05 12.2516 19.9L11.7016 19.45H9.50156L8.95156 19.9Z"
        fill="url(#paint0_linear_10910_14879)"
      />
      <path
        d="M14.5 12.7999L14.95 9.9999H12.3V8.0499C12.3 7.2499 12.6 6.6499 13.8 6.6499H15.1V4.0999C14.4 3.9999 13.6 3.8999 12.9 3.8999C10.6 3.8999 9 5.2999 9 7.7999V9.9999H6.5V12.7999H9V19.8499C9.55 19.9499 10.1 19.9999 10.65 19.9999C11.2 19.9999 11.75 19.9499 12.3 19.8499V12.7999H14.5Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_10910_14879"
        x1="10.6021"
        y1="19.3045"
        x2="10.6021"
        y2="-0.00368389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062E0" />
        <stop offset="1" stopColor="#19AFFF" />
      </linearGradient>
      <clipPath id="clip0_10910_14879">
        <rect width="20" height="20" fill="white" transform="translate(0.601562)" />
      </clipPath>
    </defs>
  </svg>
);

export const XIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2052 1.875H17.9619L11.9394 8.75833L19.0244 18.125H13.4769L9.13188 12.4442L4.16021 18.125H1.40187L7.84354 10.7625L1.04688 1.875H6.73521L10.6627 7.0675L15.2052 1.875ZM14.2377 16.475H15.7652L5.90521 3.43833H4.26604L14.2377 16.475Z"
      fill={props?.fill || '#0B0B0B'}
    />
  </svg>
);

export const YoutubeIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.5806 7.19355C21.3548 6.32258 20.6774 5.64516 19.8065 5.41935C18.2581 5 12 5 12 5C12 5 5.74194 5 4.19355 5.41935C3.32258 5.64516 2.64516 6.32258 2.41935 7.19355C2 8.77419 2 12 2 12C2 12 2 15.2581 2.41935 16.8065C2.64516 17.6774 3.32258 18.3548 4.19355 18.5806C5.74194 19 12 19 12 19C12 19 18.2581 19 19.8065 18.5806C20.6774 18.3548 21.3548 17.6774 21.5806 16.8065C22 15.2581 22 12 22 12C22 12 22 8.77419 21.5806 7.19355ZM10 15V9L15.1935 12L10 15Z"
      fill={props?.fill || '#FF0000'}
    />
  </svg>
);

export const WebsiteIcon = (props: IconProps) => (
  <div className="w-6 h-5 flex justify-center items-center text-primary">
    <GlobeAltIcon strokeWidth={1.5} {...props} />
  </div>
);

type SocialIconProps = SVGProps<SVGSVGElement> & {
  type: SocialMediaType | 'WEBSITE';
};

export const SocialIcon = (props: SocialIconProps) => {
  const { type } = props;

  switch (type) {
    case 'INSTAGRAM':
      return <InstagramIcon {...props} />;
    case 'FACEBOOK':
      return <FacebookIcon {...props} />;
    case 'TIKTOK':
      return <TikTokIcon {...props} />;
    case 'LINKEDIN':
      return <LinkedInIcon {...props} />;
    case 'X':
      return <XIcon {...props} />;
    case 'YOUTUBE':
      return <YoutubeIcon {...props} />;
    case 'WEBSITE':
      return <WebsiteIcon {...props} />;
    default:
      return null;
  }
};
